import React from "react";
import styled from "styled-components";
import { EnHeadline } from "styles/sharedStyles";
import { designTokens, getTypography } from "styles/designTokens";

interface Props {
  headline: string;
  description: {
    text: string;
    highlight: string;
    text2: string;
  };
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 24px 0;
`;

const Title = styled(EnHeadline)`
  font-size: 40px;
  line-height: 1.3;
  font-weight: 700;
  background: linear-gradient(90deg, #5c6eff, #7385ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 12px;
`;

const Description = styled.p`
  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.secondary};
  white-space: pre-line;
  line-height: 160%;
  letter-spacing: -0.2px;
  margin: 0 0 0 2px;

  span {
    color: ${designTokens.colors.font.primary};
    font-weight: 600;
  }
`;

const IntroContainer: React.FC<Props> = ({ headline, description }) => {
  return (
    <Container>
      <Title>{headline}</Title>
      <Description>
        {description.text}
        <span>{description.highlight}</span>
        {description.text2}
      </Description>
    </Container>
  );
};

export default IntroContainer;
